import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Mails } from 'lucide-react';

import { SendConfirmationEmailForm } from '@/components/forms/send-confirmation-email';

export const UnverifiedAccount = () => {
  useLocale();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="flex items-start">
        <div className="me-4 mt-1 hidden md:block">
          <Mails className="h-10 w-10 text-primary" strokeWidth={2} />
        </div>
        <div className="">
          <h2 className="font-bold text-2xl md:text-4xl">{t('auth.confirmEmail')}</h2>

          <p className="mt-4 text-muted-foreground">
            {t('auth.toGainAccessToYourAccountPleaseConfirmYour')}{' '}
          </p>

          <p className="mt-4 text-muted-foreground">
            {t('auth.ifYouDonTFindTheConfirmationLinkIn')}{' '}
          </p>

          <SendConfirmationEmailForm />
        </div>
      </div>
    </div>
  );
};
